import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'out-home-models',
  imports: [CommonModule, RouterLink],
  templateUrl: './home-models.component.html',
  styleUrl: './home-models.component.scss',
})
export class HomeModelsComponent {
  models = [
    {
      image: '/assets/images/model-s.png',
      model: 'Model S',
      link: '/used-tesla-model-s-for-sale',
    },
    {
      image: '/assets/images/model-3.png',
      model: 'Model 3',
      link: '/used-tesla-model-3-for-sale',
    },
    {
      image: '/assets/images/model-x.png',
      model: 'Model X',
      link: '/used-tesla-model-x-for-sale',
    },
    {
      image: '/assets/images/model-y.png',
      model: 'Model Y',
      link: '/used-tesla-model-y-for-sale',
    },
    {
      image: '/assets/images/cybertruck.png',
      model: 'Cybertruck',
      link: '/used-tesla-cybertruck-for-sale',
    },
  ];
}
